import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vShow as _vShow, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2ff22901"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "general" }
const _hoisted_5 = {
  key: 0,
  class: "modal"
}
const _hoisted_6 = { class: "contenedor" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, "Filtros", -1))
const _hoisted_8 = { class: "contenido" }
const _hoisted_9 = { class: "contenido" }
const _hoisted_10 = { class: "grid" }
const _hoisted_11 = { class: "productos" }
const _hoisted_12 = { class: "grid-fields" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, " Productos ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Nuevo Producto ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "responsive-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ListadoComponent = _resolveComponent("ListadoComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        ($data.cargando)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_Navbar),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      ($data.showModal)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (this.showModalMethod())),
                  for: "btn-modal"
                }, "X"),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Filters, {
                    filterProductos: $options.filterProductos,
                    search: $options.search,
                    filteredProductos: _ctx.filteredProductos
                  }, null, 8, ["filterProductos", "search", "filteredProductos"])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("input", {
                id: "buscar",
                type: "buscar",
                onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => ($options.search($data.buscar)), ["enter"])),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.buscar) = $event)),
                placeholder: "Buscar por Descripción",
                class: "form-control"
              }, null, 544), [
                [_vModelText, $data.buscar]
              ])
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (this.$router.push(`/productos/new`)), ["prevent"]))
              }, _hoisted_16, 512), [
                [_vShow, !this.conectando]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createVNode(_component_ListadoComponent, { productos: $data.productos }, null, 8, ["productos"]), [
              [_vShow, !$data.cargando]
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, !$data.cargando]
    ])
  ]))
}